// assets
import {
    IconDashboard,
    IconBuilding,
    IconBook,
    IconQuestionMark,
    IconUsers,
    IconSettings,
    IconLogout,
    IconChartLine,
    IconPhoto,
    IconMessages,
    IconMail,
    IconLayoutBoard,
    IconLock,
    IconBoxMultiple
} from '@tabler/icons';
import { BarChart } from '@mui/icons-material';
import appUrls from '../appUrls';

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const main = {
    id: 'main-routes',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: appUrls.DASHBOARD,
            icon: IconDashboard,
            breadcrumbs: false,
            include: 'common'
        },
        {
            id: 'students',
            title: 'Students',
            type: 'item',
            url: appUrls.STUDENT,
            icon: IconUsers,
            breadcrumbs: false,
            include: 'studentList'
        },
        {
            id: 'common_page_data',
            title: 'Common Page Data',
            type: 'item',
            url: appUrls.COMMON_PAGE_DATA,
            icon: IconBoxMultiple,
            breadcrumbs: false,
            include: 'commonPageData'
        },
        {
            id: 'profile',
            title: 'Edit Profile',
            type: 'item',
            url: appUrls.PROFILE,
            icon: IconSettings,
            breadcrumbs: false,
            include: 'common'
        },
        {
            id: 'questions',
            title: 'Questions',
            type: 'item',
            url: appUrls.QUESTIONS,
            icon: IconQuestionMark,
            breadcrumbs: false,
            include: 'profileQuestions'
        },
        {
            id: 'poll-questions',
            title: 'Poll Questions',
            type: 'item',
            url: appUrls.POLL_QUESTIONS,
            icon: IconChartLine,
            breadcrumbs: false,
            include: 'includePoll'
        },
        {
            id: 'gallery',
            title: 'Gallery',
            type: 'item',
            url: appUrls.GALLERY,
            icon: IconPhoto,
            breadcrumbs: false,
            include: 'includeGallery'
        },

        {
            id: 'collage',
            title: 'Collage',
            type: 'item',
            url: appUrls.COLLAGE,
            icon: IconLayoutBoard,
            breadcrumbs: false,
            include: 'collagePhoto'
        },
        {
            id: 'testimonial',
            title: 'Testimonials',
            type: 'item',
            url: appUrls.TESTIMONIAL,
            icon: IconMessages,
            breadcrumbs: false,
            include: 'includeTestimonials'
        },
        {
            id: 'contact',
            title: 'Contact',
            type: 'item',
            url: appUrls.CONTACT,
            icon: IconMail,
            breadcrumbs: false,
            include: 'common'
        },

        {
            id: 'change_password',
            title: 'Change Password',
            type: 'item',
            url: appUrls.CHANGE_PASSWORD,
            icon: IconLock,
            breadcrumbs: false,
            include: 'common'
        },
        {
            id: 'logout',
            title: 'Logout',
            type: 'item',
            url: appUrls.LOGOUT,
            icon: IconLogout,
            breadcrumbs: false,
            include: 'logout'
        }
    ]
};

export default main;
